



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { IField } from '@/fields/types/field';
import FieldSettingsContainer from '@/fields/context-menu/components/FieldSettingsContainer.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';

@Component({
  components: {
    FieldSettingsContainer,
    Button,
    Checkbox,
  },
})
export default class InitialsFieldSettings extends Vue {
  @Prop() field!: IField;
  @Prop() height!: number;

  isEditable: boolean = this.field.isEditable;

  handleIsEditable(value: boolean) {
    this.isEditable = value;
  }

  handleSave() {
    const payload: Partial<IField> = { isEditable: this.isEditable };
    this.$emit('update', payload);
  }
}
